import PropTypes from 'prop-types';

import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import ExpressInterestFormError from './ExpressInterestFormError';
import ExpressInterestStepContainer from './ExpressInterestStepContainer';
import messages from '../../../locale/messages';
import ScheduleButton from '../ScheduleButton';
import style from '../ScheduleForm/ScheduleForm.scss';
import {customisedIntlFormatMessage} from '../../../utils/helpers';
import { 
  INSTUMENTAL_MUSIC_PROGRAM_CODE, 
  MT_EXPRESSED_INTEREST_PROGRAMS,
  MT_AUDITION_PROGRAMS
 } from '../../../constants';

const ExpressInterestSubmitStep = ({
  expressed,
  expressInterestForm,
  expressedInterestsCount,
  intl,
  isMS,
  isLaGuardia,
  localMessages,
  onSubmit,
  program,
}) => {
  const schoolNameButtonClasses = ['button--no-style', style.scheduleFormStepButton];
  const actionButtonClasses = ['button--no-style', style.scheduleFormStepButton];

  // There is a 2 assessment limit for MS process.
  // Submit button will be disabled if the limit is reached
  let isMTAuditionProgram = false;
  if(program.schedule)
    isMTAuditionProgram = MT_AUDITION_PROGRAMS.includes(program.schedule.name)
  else if(program.name)
    isMTAuditionProgram = MT_AUDITION_PROGRAMS.includes(program.name)
  let canSubmit = true;
  if (isMS && expressedInterestsCount >= 2) {
    canSubmit = false;
  }

  if (expressed) {
    schoolNameButtonClasses.push(style.scheduleFormStepButtonDone);
    actionButtonClasses.push(style.scheduleFormStepButtonDone);
  } else {
    actionButtonClasses.push(style.scheduleFormStepButtonActive);
  }
  let scheduleButtonLabel = customisedIntlFormatMessage(intl, messages.buttonSubmitRegistration);
  if (isMS) {
    if(isMTAuditionProgram) {
      scheduleButtonLabel = program.schedule.pre_submission_popup_button_name;
    }
    else
      scheduleButtonLabel = program.schedule.pre_submission_popup_button_name;
  }
  if (isLaGuardia) {
    scheduleButtonLabel = customisedIntlFormatMessage(intl, messages.buttonSubmitLGAInstrumentsData);
  }
  if (!canSubmit) {
    return (
      <SubmitStepLimitReached
        expressed={expressed}
        style={style}
        localMessages={localMessages}
        intl={intl}
        actionButtonClasses={actionButtonClasses}
        scheduleButtonLabel={scheduleButtonLabel}
        expressInterestForm={expressInterestForm}
        isMTAuditionProgram={isMTAuditionProgram}
        program={program}
      />
    );
  }
  let programCode = '';
  if(isMS){
    programCode = program.school.name;
  }
  else if(!isLaGuardia){
    programCode = program.code;
  }
  else{
    programCode = program.program.code;
  }
  return (
    <div>
      {expressed && <StepTitle program={program}/>} 
      <div>
        <StartStepContainer isLaGuardia={isLaGuardia} program={program} schoolNameButtonClasses={schoolNameButtonClasses} style={style} />
        {isLaGuardia === false && <AccommodationStepContainer isLaGuardia={isLaGuardia} program={program} schoolNameButtonClasses={schoolNameButtonClasses} style={style} />}
        {(isMS && MT_EXPRESSED_INTEREST_PROGRAMS.includes(programCode)) && (
          <ExpressInterestStepContainer title={intl.formatMessage(localMessages.saturdaySundayOptionTitle)} expressed={true} />
        )}
        {programCode === INSTUMENTAL_MUSIC_PROGRAM_CODE && (
          <ExpressInterestStepContainer
            title={customisedIntlFormatMessage(intl, localMessages.selectInstrumentsTitle)}
            style={style}
          />
        )}
        <SubmitStepContainer
          isLaGuardia={isLaGuardia}
          isMS={isMS}
          intl={intl}
          actionButtonClasses={actionButtonClasses}
          expressed={expressed}
          localMessages={localMessages}
          style={style}
          canSubmit={canSubmit}
          isMTAuditionProgram={isMTAuditionProgram}
          program={program}
        />
      </div>
      {!expressed && (
        <div>
          <ScheduleButton
            label={scheduleButtonLabel}
            icon="Check"
            onClick={onSubmit}
            disabled={!canSubmit}
            style={style}
          />
          {expressInterestForm.error && <ExpressInterestFormError />}
        </div>
      )}
    </div>
  );
};
ExpressInterestSubmitStep.propTypes = {
  expressed: PropTypes.bool.isRequired,
  expressInterestForm: PropTypes.shape({
    error: PropTypes.bool,
  }).isRequired,
  expressedInterestsCount: PropTypes.number.isRequired,
  intl: PropTypes.object.isRequired,
  isMS: PropTypes.bool.isRequired,
  isLaGuardia: PropTypes.bool.isRequired,
  localMessages: PropTypes.shape({
    selectInstrumentsTitle: PropTypes.string,
    saturdaySundayOptionTitle: PropTypes.string,
  }).isRequired,
  onSubmit: PropTypes.func.isRequired,
  program: PropTypes.shape({
    code: PropTypes.string,
  }).isRequired,
};

const StepTitle = ({ program }) => {
  if (!program?.schedule?.success_message) {
    return null;
  }

  return(
  <div className={style.scheduleFormScheduleTitleContainer}>
    <div className={style.scheduleFormScheduleTitle}>
      {program.schedule.success_message}
    </div>
  </div>)
};
StepTitle.propTypes = {
  program: PropTypes.shape({
    name: PropTypes.string.isRequired,
    code: PropTypes.string.isRequired,
    school: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired
};

const StartStepContainer = ({ isLaGuardia, program, schoolNameButtonClasses }) => {
  let schoolName = '';
  if(!isLaGuardia){
    schoolName = program.school.name;
  }
  else{
    schoolName = program.directory_school_name;
  }
  return(
    <div className={style.scheduleFormStepContainer}>
      <div className={style.scheduleFormStepTitleContainer}>
        <button disabled aria-label={schoolName} className={classNames(...schoolNameButtonClasses)}>
        {/* <button disabled aria-label={program.directory_school_name} className={classNames(...schoolNameButtonClasses)}> */}
          <div className={style.scheduleFormStepButtonIcon}>
            <i className="icon-Check" />
          </div>
          <div className={style.scheduleFormStepTitle}>
            <div>{schoolName}</div>
            {/* <div>{program.directory_school_name}</div> */}
            <div>
              <i className="icon-Star" /> {program.name}
            </div>
          </div>
        </button>
      </div>
    </div>
  );
};
StartStepContainer.propTypes = {
  isLaGuardia: PropTypes.bool.isRequired,
  program: PropTypes.shape({
    name: PropTypes.string,
    school: PropTypes.shape({
      name: PropTypes.string,
    }),
  }).isRequired,
  schoolNameButtonClasses: PropTypes.arrayOf(PropTypes.string).isRequired,
};

const AccommodationStepContainer = ({ isLaGuardia, program, schoolNameButtonClasses }) => {
  let schoolName = '';
  if(!isLaGuardia){
    schoolName = program.school.name;
  }
  else{
    schoolName = program.directory_school_name;
  }
  return(
    <div className={style.scheduleFormStepContainer}>
      <div className={style.scheduleFormStepTitleContainer}>
        <button
          aria-label={schoolName}
          // aria-label={program.directory_school_name}
          onClick={() => {
            console.warn('Missing callback');
          }}
          className={classNames(...schoolNameButtonClasses)}
        >
          <div className={style.scheduleFormStepButtonIcon}>
            <i className="icon-Check" />
          </div>
          <div className={style.scheduleFormStepTitle}>
            <div>Accommodations</div>
          </div>
        </button>
      </div>
    </div>
  );
};
AccommodationStepContainer.propTypes = {
  isLaGuardia: PropTypes.bool.isRequired,
  program: PropTypes.shape({
    school: PropTypes.shape({
      name: PropTypes.string,
    }),
  }).isRequired,
  schoolNameButtonClasses: PropTypes.arrayOf(PropTypes.string).isRequired,
};

const SubmitStepContainer = ({
  isLaGuardia,
  isMS,
  intl,
  actionButtonClasses,
  expressed,
  localMessages,
  canSubmit,
  isMTAuditionProgram,
  program
}) => {
  let buttonAreaLabel = customisedIntlFormatMessage(intl, messages.buttonExpressInterest);
  let buttonText = <FormattedMessage {...messages.buttonExpressInterest} />;
  let bodyCopy = (
    <div>
      <FormattedMessage {...localMessages.expressionOfInterestInfo} />
    </div>
  );
  let noteText;
  if (isLaGuardia) {
    buttonAreaLabel = customisedIntlFormatMessage(intl, messages.buttonExpressInterestLaGuardiaCase);
    buttonText = <FormattedMessage {...messages.buttonExpressInterestLaGuardiaCase} />;
    bodyCopy = "";
  }
  if (isMS) {
    buttonAreaLabel = customisedIntlFormatMessage(intl, messages.generalStringRegisterLabel);
    buttonText = customisedIntlFormatMessage(intl, messages.generalStringRegisterLabel);
    bodyCopy = canSubmit ? <div dangerouslySetInnerHTML={{ __html: program.schedule.program_assessment_description }} /> : "";

    if(isMTAuditionProgram){
      buttonAreaLabel = customisedIntlFormatMessage(intl, messages.buttonExpressInterest);
      buttonText = customisedIntlFormatMessage(intl, messages.buttonExpressInterest);
      bodyCopy = "";
      noteText = (
        <div className={style.scheduleFormHelp}>
          <strong>
            <i>
              {program?.schedule?.mt_audition_program_note || (
                <FormattedMessage {...messages.mtAuditionProgramNote} />
              )}
            </i>
          </strong>
        </div>
      );
    }
    // Copy that follows disabled button when registered over capacity
    if (!canSubmit) {
      noteText = (
        <div className={style.scheduleFormHelp}>
          <strong>
            <i>
              {program?.schedule?.talent_test_limit_reached_note || (
                <FormattedMessage {...messages.talentTestLimitReachedNote} />
              )}
            </i>
          </strong>
        </div>
      );
    }
  }
  return (
    <div className={style.scheduleFormStepContainer}>
      <div className={style.scheduleFormStepTitleContainer}>
        <button disabled aria-label={buttonAreaLabel} className={classNames(...actionButtonClasses)}>
          <span className={style.scheduleFormStepButtonIcon}>
            <i className="icon-Check" />
          </span>
          <span className={style.scheduleFormStepTitle}>{buttonText}</span>
        </button>
      </div>
      {!expressed && !isLaGuardia && (
        <div className={style.scheduleFormStep}>
          {bodyCopy}
          {noteText}
        </div>
      )}
    </div>
  );
};
SubmitStepContainer.propTypes = {
  isLaGuardia: PropTypes.bool.isRequired,
  isMS: PropTypes.bool.isRequired,
  intl: PropTypes.object.isRequired,
  actionButtonClasses: PropTypes.arrayOf(PropTypes.string).isRequired,
  expressed: PropTypes.bool.isRequired,
  localMessages: PropTypes.shape({
    // expressionOfInterestSuccessLaGuardia: PropTypes.string,
    expressionOfInterestSuccessLaGuardia: PropTypes.object,
    expressionOfInterestSuccess: PropTypes.string,
    expressionOfInterestInfo: PropTypes.string,
    expressionOfInterestInfoLaGuardiaCase: PropTypes.string,
    msRegisterCopy: PropTypes.string,
  }).isRequired,
  canSubmit: PropTypes.bool.isRequired,
  isMTAuditionProgram: PropTypes.bool.isRequired,
  program: PropTypes.shape({
    name: PropTypes.string.isRequired,
    code: PropTypes.string.isRequired,
    school: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired
};

const SubmitStepLimitReached = ({
  expressed,
  localMessages,
  intl,
  actionButtonClasses,
  scheduleButtonLabel,
  expressInterestForm,
  isMTAuditionProgram,
  program,
}) => {
  const isLaGuardia = false;
  return (
    <div>
      {expressed && <StepTitle program={program}/>} 
      <div>
        <SubmitStepContainer
          isLaGuardia={isLaGuardia}
          isMS
          intl={intl}
          actionButtonClasses={actionButtonClasses}
          expressed={expressed}
          localMessages={localMessages}
          style={style}
          canSubmit={false}
          isMTAuditionProgram={isMTAuditionProgram}
          program={program}
        />
      </div>
      {!expressed && (
        <div>
          <ScheduleButton label={scheduleButtonLabel} icon="Check" onClick={() => {}} disabled style={style} />
          {expressInterestForm.error && <ExpressInterestFormError />}
        </div>
      )}
    </div>
  );
};
SubmitStepLimitReached.propTypes = {
  expressed: PropTypes.bool.isRequired,
  localMessages: PropTypes.shape({}).isRequired,
  intl: PropTypes.shape({}).isRequired,
  actionButtonClasses: PropTypes.arrayOf(PropTypes.string).isRequired,
  scheduleButtonLabel: PropTypes.string.isRequired,
  expressInterestForm: PropTypes.shape({
    error: PropTypes.bool,
  }).isRequired,
  isMTAuditionProgram: PropTypes.bool.isRequired,
};

export default ExpressInterestSubmitStep;
